"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubCategoryReducer = exports.createSubCategoryReducer = exports.fetchSubCategoryReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const subCategoriesAction_1 = require("./subCategoriesAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const fetchSlice = (0, toolkit_1.createSlice)({
    name: "terminalOnline/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subCategoriesAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(subCategoriesAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(subCategoriesAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
const createSubCategorySlice = (0, toolkit_1.createSlice)({
    name: "subCategories/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subCategoriesAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(subCategoriesAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(subCategoriesAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
const updateSubCategorySlice = (0, toolkit_1.createSlice)({
    name: "subCategories/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subCategoriesAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(subCategoriesAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(subCategoriesAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.fetchSubCategoryReducer = fetchSlice.reducer;
exports.createSubCategoryReducer = createSubCategorySlice.reducer;
exports.updateSubCategoryReducer = updateSubCategorySlice.reducer;
